import React from "react";

class MovieRow extends React.Component {
  viewMovie() {
    // console.log("Trying to view movie")
    // console.log(this.props.movie.title)
    const url = "https://www.themoviedb.org/movie/" + this.props.movie.id;
    window.location.href = url;
  }

  render() {
    return (
      <div className="jumbotron">
        <table key={this.props.movie.id}>
          <tbody>
            <tr>
              <td>
                <img
                  alt="poster"
                  width="120"
                  src={this.props.movie.poster_src}
                />
              </td>
              <td className="pl-5">
                <h3>{this.props.movie.title}</h3>
                <p>{this.props.movie.overview}</p>
                <input
                  type="button"
                  onClick={this.viewMovie.bind(this)}
                  value="View"
                  className="btn btn-dark"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default MovieRow;
